import { useRequiredContext } from '../../../contexts/utils'
import { NotificationsContext } from '../../../contexts/notifications/NotificationsContext'

/**
 * @deprecated prefer `notify` from `@retailer-platform/shared-components` instead
 */
export const useNotifications = () => useRequiredContext(NotificationsContext)
